import apiClient, { unwrap } from './client'

export interface AntispamConfig {
  greylist_enabled: boolean
  greylist_delay_secs: number
  dnsbl_enabled: boolean
  dnsbl_zones: string[]
  min_receive_interval_secs: number
}

export interface AntispamInput {
  greylist_enabled: boolean
  greylist_delay_secs: number
  dnsbl_enabled: boolean
  dnsbl_zones: string[]
  min_receive_interval_secs: number
}

export const antispamApi = {
  get() {
    return unwrap<AntispamConfig>(apiClient.get('/antispam'))
  },
  put(input: AntispamInput) {
    return unwrap<AntispamConfig>(apiClient.put('/antispam', input))
  },
}
